import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2, MessageCircle, ArrowLeft } from "lucide-react";
import { api, waLink } from "../lib/api";

export default function PaymentResult({ success = false }) {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState(success ? "pending" : "cancelled");

  useEffect(() => {
    if (!success || !sessionId) return;
    let tries = 0;
    const tick = async () => {
      try {
        const { data } = await api.get(`/api/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
      } catch (e) {}
      tries += 1;
      if (tries < 40) setTimeout(tick, 3000);
    };
    tick();
  }, [success, sessionId]);

  const paid = status === "paid";

  return (
    <div data-testid="payment-result-page" className="min-h-screen bg-ink text-paper flex items-center justify-center p-6 grain relative overflow-hidden">
      <div className="absolute inset-0 ledger-bg" />
      <div className="relative max-w-lg w-full text-center border border-line-dark bg-ink-2/80 backdrop-blur p-10 md:p-14">
        {success ? (
          paid ? (
            <>
              <CheckCircle2 size={64} className="mx-auto text-emerald-400" />
              <h1 className="mt-6 font-display font-extrabold text-4xl tracking-tightest">
                Pagamento confirmado!
              </h1>
              <p className="mt-4 text-paper/65 leading-relaxed">
                Recebemos seu pagamento. Um especialista da Contabiltec vai
                entrar em contato pelo WhatsApp para começar o quanto antes.
              </p>
            </>
          ) : (
            <>
              <Loader2 size={64} className="mx-auto text-crimson-bright animate-spin" />
              <h1 className="mt-6 font-display font-extrabold text-4xl tracking-tightest">
                Confirmando pagamento...
              </h1>
              <p className="mt-4 text-paper/65 leading-relaxed">
                Aguarde um instante, estamos confirmando com o Stripe.
              </p>
            </>
          )
        ) : (
          <>
            <XCircle size={64} className="mx-auto text-crimson-bright" />
            <h1 className="mt-6 font-display font-extrabold text-4xl tracking-tightest">
              Pagamento cancelado
            </h1>
            <p className="mt-4 text-paper/65 leading-relaxed">
              Nenhuma cobrança foi feita. Se preferir, fale com um especialista
              pelo WhatsApp — a pré-análise é gratuita.
            </p>
          </>
        )}

        <div className="mt-9 flex flex-col sm:flex-row gap-3 justify-center">
          <a
            data-testid="payment-result-whatsapp"
            href={waLink("Olá! Acabei de contratar um serviço pelo site da Contabiltec.")}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-crimson hover:bg-crimson-bright text-paper font-semibold px-6 py-3.5 rounded-full transition-colors"
          >
            <MessageCircle size={18} /> Falar com especialista
          </a>
          <Link
            data-testid="payment-result-back"
            to="/"
            className="inline-flex items-center justify-center gap-2 border border-line-dark hover:border-paper/50 font-medium px-6 py-3.5 rounded-full transition-colors"
          >
            <ArrowLeft size={18} /> Voltar ao site
          </Link>
        </div>
      </div>
    </div>
  );
}
